<template>
  <div>

    <v-card class = "card-curvey">
      <v-layout row wrap class="align-center">
        <v-flex xs4>
          <h3>Entity Extraction</h3>
        </v-flex>
        <v-spacer />
        <v-btn
          :disabled = "!itemsSelected || !itemsSelected.length "
          color = "blue-grey"
          class = "nlp-nav-btn"
          small
          @click="deleteDialog = true"
          outline>
          <span
            class="botter-trash-icon"
            style="padding-right: 6px"/>
          Delete
        </v-btn>
        <v-btn
          color = "blue-grey"
          class = "nlp-nav-btn"
          small
          outline
          @click="openAddItem"
        >
          <v-icon>add</v-icon>
          New Item
        </v-btn>
      </v-layout>
      <v-flex xs12>
        <v-data-table
          v-model="itemsSelected"
          :headers="headers"
          :items="actions[0].entities"
          item-key="entityName"
          :pagination.sync="$store.state.settings.pagination"
          select-all
          class="elevation-1 nlp-data-table">
          <template
            slot="items"
            slot-scope = "props" >
            <tr>
              <td>
                <v-checkbox
                  v-model="props.selected"
                  primary
                  color="primary"
                  hide-details />
              </td>
              <td>
                {{props.item.entityName}}
              </td>
              <td>
                {{props.item.saveTo}}
              </td>
              <td>
                {{props.item.defaultValue}}
              </td>
              <td class="text-xs-center">
                <v-checkbox
                  v-model="props.item.required"
                  primary
                  color="primary"
                  hide-details />
              </td>
              <td class="text-xs-right">
                <v-icon @click="editItem(props)">more_horiz</v-icon>
              </td>
            </tr>
          </template>
        </v-data-table>
      </v-flex>
      <v-dialog v-model="itemFormModal" width="400">
        <entity-extraction-form
          :selected-item="selectedItem"
          :open-mode="openMode"
          @saveItem="saveItem"
          @addItem="addItem"
          @closeDialog="itemFormModal = false"/>
      </v-dialog>
      <v-dialog v-model="deleteDialog" width="400">
        <delete-dialog
          title="Entities"
          @closeDialog="deleteDialog = false"
          @onDelete="deleteItems"
        />
      </v-dialog>
    </v-card>

    <v-card class="card-curvey">
      <div
        v-for="(replay,index) in actions"
        class="replay"
        :key="index">
        <replay :replay="replay" :blocks="blocks" autocomplete-variables allow-new-tabs></replay>
        <v-btn v-if="index > 0" @click="deleteReplay(index)" class="delete-replay" fab small color=""><v-icon color="#666">delete_outline</v-icon></v-btn>
      </div>
      <v-layout>
        <v-spacer />
        <v-btn  class="add-random-replay font-weight-bold" flat  color="primary"  @click="addNewReplay"><v-icon>add</v-icon> Add Another Answer</v-btn>
        <v-spacer />

        <v-btn style="alignment: right"
               color="primary"
               @click="saveActions">
          Save
        </v-btn>
      </v-layout>


    </v-card>


  </div>

</template>

<script>
  import _ from 'lodash'
  import entityExtractionForm from "./entityExtractionForm";
  import deleteDialog from "../../common/deleteDialog";
  import replay from "../../ai/replays";
  import common from "../../../utils/common";
  export default {
    name: "entityExtraction",
    components: {
      entityExtractionForm,
      deleteDialog,
      replay
    },
    data() {
      return {
        replies: [],
        actions: [
            {
              blocks: [],
              entities: [],
              errorOrEmpty: 0,
              text: "",
              type: "text",
              hasEntity: "true"
            }
          ],
        itemsSelected: [],
        blocks: [],
        selectedItem: {},
        deleteDialog: false,
        openMode: 'add',
        itemFormModal: false,
        headers: [
          {
            text: 'Entity Name',
            align: 'left',
            sortable: true,
            value: 'entityName'
          },
          {
            text: 'Attribute name',
            value: 'saveTo',
            align: 'left'
          },
          {
            text: 'Default value',
            value: 'defaultValue',
            align: 'left'
          },
          {
            text: 'Required',
            value: 'required',
            align: 'left'
          },
          {
            text: 'More',
            value: 'more',
            align: 'right'
          }
        ]
      }
    },
    mounted() {
      this.getIntentData()
      this.getBlockList()
      if (this.$store.state.nlp.selectedIntent.actions) {
        this.actions = this.$store.state.nlp.selectedIntent.actions
      }
    },
    methods: {
      getIntentData () {
          this.$http_bot.get('intents')
          .then(response=>{

          })
      },
      editItem (item) {
        this.selectedItem = _.cloneDeep(item)
        this.openMode = 'edit'
        this.itemFormModal = true
      },
      saveItem (item) {
        this.itemFormModal = false
        this.actions[0].entities[item.index].entityName = item.item.entityName
        this.actions[0].entities[item.index].defaultValue = item.item.defaultValue
        this.actions[0].entities[item.index].saveTo = item.item.saveTo
        this.actions[0].entities[item.index].required = item.item.required
        this.actions[0].entities[item.index].regex = item.item.regex
        this.actions[0].entities[item.index].errorMessage = item.item.errorMessage
        this.actions[0].entities[item.index].question = item.item.question
        this.selectedItem = {item:{}}
        this.saveActions()
      },
      addItem (item) {
        if(!this.actions[0].entities) {
          this.actions[0].entities = []
        }
        if(this.actions[0].entities && this.actions[0].entities.length) {
          this.actions[0].hasEntity = 'true'
        }
        this.actions[0].entities.push(item.item)
        this.itemFormModal = false
        this.selectedItem = {item:{}}
        this.saveActions()
      },
      openAddItem() {
        this.openMode = 'add'
        this.selectedItem = {item:{}}
        this.itemFormModal = true
      },
      deleteItems() {
        for (let i=0; i<this.itemsSelected.length; i++) {
          let index = _.findIndex(this.actions[0].entities,(item)=>{
            return this.itemsSelected[i].entityName === item.entityName
          })
          if (index !== -1) {

            this.actions[0].entities.splice(index,1)
          }
          index = -1
        }
        this.deleteDialog = false
        this.saveActions()
      },
      addNewReplay(){
        this.actions.push({
          blocks: [],
          entities: [],
          errorOrEmpty: 0,
          text: "",
          type: "text",
          hasEntity: "true"
        })
      },
      deleteReplay(index) {
        this.actions.splice(index,1)
      },
      getBlockList () {
        this.$store.dispatch('setLoader',true)
        this.$http_bot.get('/blocks')
          .then(response=>{
            this.blocks = response.data
            this.$store.dispatch('setLoader',false)
          })
          .catch(error=>{
            this.$store.dispatch('setLoader',false)
            if (error.response && error.response.status === 401) {
              common.logOut()
            } else {
              this.$store.dispatch('setErrorMessage', true)
            }
          })
      },
      saveActions() {
        this.$store.dispatch('setLoader',true)
        let intentId = this.$store.state.nlp.selectedIntent.id
        for (let i=0; i<this.actions.length;i++) {
          this.actions[i].entities = this.actions[0].entities
          this.actions[i].event = {
            attributes: ["last_message"],
            name: this.$store.state.nlp.selectedIntent.name,
            type: 'nlp'
          }
        }
        this.$http_nlp.put(`apps/${this.$store.state.nlp.selectedApp.id}/intents/${intentId}/actions`,this.actions)
        .then(response=> {
          this.$store.dispatch('setLoader',false)
        })
        .catch(error=>{
          this.$store.dispatch('setLoader',false)
          if (error.response && error.response.status === 401) {
            common.logOut()
          } else {
            this.$store.dispatch('setErrorMessage', true)
          }
        })
      },
    },
    computed: {
      storeActions() {
        return this.$store.state.nlp.selectedIntent.actions
      }
    },
    watch: {
      storeActions: {
        immediate: true,
        deep: true,
        handler(val) {
          if(val) this.actions = val
        }
      }
    }
  }
</script>

<style scoped>

</style>
